import React, { useState } from "react";
import Helpers from "../../../../../constants/helpers";

export const PasswordInput = ({ register, errors, placeholderText, displayPasswordStrength }) => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    return <div className="form-group mb-2">
        <input
            className={`form-control ${errors.password && 'upsell-input-invalid'}`}
            type={passwordVisible ? "text" : "password"}
            placeholder={placeholderText}
            autoComplete="new-password"
            id="Password"
            onKeyUp={() => validatePasswordStrength('#Password')} onBlur={() => hidePasswordStrengthText()}
            {...register("password", { required: "Password is required" })}
        />
        <img
            src={Helpers.getBlobFileUrl("/images/eye.svg")}
            className="opacity-point-4 togglePasswordImg cursor-pointer p-2"
            onClick={() => setPasswordVisible((prev) => !prev)}
            title={passwordVisible ? "Hide Password" : "Show Password"}
            alt={passwordVisible ? "Hide Password" : "Show Password"}
        />
        {
            displayPasswordStrength && (
            <>
                <meter max="4" id="password-strength-meter" className="d-none"></meter>
                <p id="password-strength-text" className="d-none text-left"></p>
            </>)
        }
        {errors.password && <div className="upsell-input-error">{errors.password.message}</div>}
    </div>;
};